import { z } from 'zod'
import { api } from '@/lib/api'
import { newIdempotencyKey } from '@/lib/idempotency'

export const faxJobSchema = z.object({
  id: z.string(),
  resident_ids: z.array(z.string()).default([]),
  to_fax_number: z.string().nullable(),
  recipient_name: z.string().nullable(),
  status: z.enum(['queued', 'sending', 'sent', 'failed', 'permanently_failed', 'canceled']),
  attempts: z.number(),
  max_attempts: z.number(),
  last_error: z.string().nullable(),
  queued_at: z.string().nullable(),
  sent_at: z.string().nullable(),
  failed_at: z.string().nullable(),
  created_at: z.string(),
})

export type FaxJob = z.infer<typeof faxJobSchema>
export type FaxStatus = FaxJob['status']

export type StatusFilter = 'all' | FaxStatus

export async function listFaxJobs(statusFilter?: FaxStatus, facilityId?: string | null): Promise<FaxJob[]> {
  const params: Record<string, string> = {}
  if (statusFilter) params.status = statusFilter
  if (facilityId) params.facility_id = facilityId
  const data = await api.get<unknown[]>('/fax-jobs', { params })
  return z.array(faxJobSchema).parse(data)
}

export async function retrySingle(id: string): Promise<FaxJob> {
  const data = await api.post<unknown>(`/fax-jobs/${id}/retry`, undefined, {
    idempotencyKey: newIdempotencyKey(),
  })
  return faxJobSchema.parse(data)
}

export async function retryBulk(ids?: string[]): Promise<{ retried: number }> {
  const body = ids ? { ids } : {}
  return api.post<{ retried: number }>('/fax-jobs/retry-bulk', body, {
    idempotencyKey: newIdempotencyKey(),
  })
}
